(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClubLifeContest',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#clublife-club').on('click', function instantiateTypeahead() {
			$('#clublifecontest-clublife_club_id').val('');
			$('#clublife-club').val('');
		});

		Adzuki.Typeahead(
			'#clublife-club',
			'/main/clubLifeSearch',
			function select(item) {
				var $self = $(this);

				$('#clublifecontest-clublife_club_id').val(item.id);
				$self.val(item.name);
			},
			function template(item) {
				var html = '';

				if (item.name !== null) {
					html += item.name;
				}

				return html;
			}
		);

		// this will prevent the drowdown header to change.
		$form.on('shown.bs.select', function optgroupSelectAll(e) {
		    e.stopPropagation();
		});

		$('select#clublifecontest-where_to_next').change(function changing(e) {
			// loop thru all options of hidden multi select input
			$('#clublifecontest-where_to_next option').each(function selecting(e, val) {
				var $self = $(this);

				// show span under select
				if ($self.is(":selected")) {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').removeClass('hidden');
				// hide span
				} else {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').addClass('hidden');
				}
			});
		}).trigger('change');
	};

}(jQuery, window.Adzuki || {}));
